import { CustomView } from '@agilelab/plugin-wb-platform';
import { SearchResultInfo } from '../types';
import { Loader } from './Loader';

export const SearchResultSystemInfo: SearchResultInfo = ({ data }) => {
  return (
    <CustomView
      id="marketplace_search_system"
      loader={<Loader />}
      data={data}
      typeId={data.kind}
      templateId={data.useCaseTemplateId}
    />
  );
};
